import {
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
} from "@mui/material";
import MKBox from "../../components/MKBox";
import MKInput from "../../components/MKInput";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";
import breakpoints from "../../assets/theme/base/breakpoints";
import { useState } from "react";
import colors from "../../assets/theme/base/colors";
import MDBox from "../../components/MDBox";

/*
SetEvents is needed for CapsLock Verification.
*/

const AuthenticationMKInput = (props) => {
  const {
    inputs,
    inputName,
    inputLabel,
    inputType,
    errorState,
    errorMessage,
    isMandatory,
    setEvents,
    setIsEnter,
    setInputs,
    formHelperTextString,
  } = props;

  /* #region  Password Toggle Visibility */
  const [passwordShown, setPasswordShown] = useState(false);

  const handleClickShowPassword = () => {
    setPasswordShown(!passwordShown);
  };
  const handleMouseDownPassword = () => {
    console.log("mouse down...");
    setPasswordShown(false);
  };
  /* #endregion */

  /* #region  On Key up/down Events */
  const onKeyUp = (event) => {
    if (setEvents != null) {
      try {
        setEvents(event);
      } catch (ex) {}
    }
  };
  const onKeyDown = (event) => {
    if (event.key === "Enter") {
      if (setIsEnter != null) {
        try {
          setIsEnter(true);
        } catch (ex) {}
      }
    }
  };

  /* #endregion */

  const handleInputChange = (event) => {
    event.persist();
    if (setInputs != null && inputs != null) {
      try {
        setInputs({
          ...inputs,
          [event.target.name]: event.target.value,
        });
      } catch (ex) {}
    }
  };

  const inputId = `${inputName}-input`;

  return (
    <MDBox
      mb={2}
      px={1}
      sx={({ breakpoints }) => ({
        width: "30rem",
        [breakpoints.down("md")]: {
          width: "100%",
          px: 0,
          mx: -1,
        },
      })}
    >
      <MDBox pb={1}>
        <InputLabel
          htmlFor={inputId}
          style={{ color: colors.JTC.jtcblue2 }}
          required={isMandatory}
        >
          <strong>{inputLabel}</strong>
        </InputLabel>
      </MDBox>

      <MKInput
        id={inputId}
        label={""}
        autoComplete="off"
        name={inputName}
        value={inputs.inputName}
        type={passwordShown == false ? inputType : "text"}
        error={errorState}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
        onChange={handleInputChange}
        InputProps={{
          endAdornment: inputType == "password" && (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onAbort={handleMouseDownPassword}
                sx={{
                  color: colors.JTCElectricBlue,
                }}
              >
                {passwordShown ? <VisibilityIcon /> : <VisibilityOffIcon />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        fullWidth
      />
      <FormHelperText error={errorState}>
        <strong>{errorState ? errorMessage : ""}</strong>
      </FormHelperText>
      {formHelperTextString != "" && (
        <FormHelperText>
          <strong>{formHelperTextString}</strong>
        </FormHelperText>
      )}
    </MDBox>
  );
};

AuthenticationMKInput.defaultProps = {
  errorState: false,
  errorMessage: "* Please fill in this field",
  isMandatory: false,
  inputName: "FEM2",
  inputType: "email",
  formHelperTextString: "",
};

AuthenticationMKInput.propTypes = {
  errorState: PropTypes.bool,
  isMandatory: PropTypes.bool,
};

export default AuthenticationMKInput;
